import { useHowTo } from './HowTo';
import { type PlayingPace, type PlayTogetherDuration } from '@league/shared/schemas';
import { PACE_OPTIONS, DURATION_OPTIONS } from '../content/playing-preferences';
import { useId } from "react";
export function PaceChoices({
  value,
  onChange,
  disabled = false,
}: {
  value: PlayingPace | null | undefined;
  onChange: (value: PlayingPace) => void;
  disabled?: boolean;
}) {
  const id = useId();
  const help = useHowTo({ title: "About play pace", lines: ["Pace describes how quickly you prefer the game to move. It is not a skill or experience rating."] });
  return (
    <fieldset disabled={disabled} className="flex min-w-0 flex-col gap-2">
      <legend className="mb-2 text-[14px] font-medium">Preferred play pace {help.button}</legend>
      {help.panel}
      {PACE_OPTIONS.map((option) => (
        <label
          key={option.value}
          className="flex items-start gap-3 rounded-md border border-light bg-paper p-3 text-[13px]"
        >
          <input
            className="mt-1 accent-deep"
            type="radio"
            name={id}
            value={option.value}
            checked={(value ?? "unknown") === option.value}
            onChange={() => onChange(option.value)}
          />
          <span>
            <span className="block font-medium">{option.label}</span>
            {option.description}
          </span>
        </label>
      ))}
    </fieldset>
  );
}
export function DurationChoices({
  value,
  onChange,
  disabled = false,
  leagueNights = false,
}: {
  value: PlayTogetherDuration;
  onChange: (value: PlayTogetherDuration) => void;
  disabled?: boolean;
  leagueNights?: boolean;
}) {
  const id = useId();
  return (
    <fieldset disabled={disabled} className="flex min-w-0 flex-col gap-2">
      <legend className="mb-2 text-[14px] font-medium">
        Play Together duration
      </legend>
      {DURATION_OPTIONS.map((option) => (
        <label
          key={option.value}
          className="flex items-start gap-3 rounded-md border border-light bg-paper p-3 text-[13px]"
        >
          <input
            className="mt-1 accent-deep"
            type="radio"
            name={id}
            value={option.value}
            checked={value === option.value}
            onChange={() => onChange(option.value)}
          />
          <span>
            <span className="block font-medium">{leagueNights ? option.value === "first_session" ? "First league night" : "Every league night" : option.label}</span>
            {option.description}
          </span>
        </label>
      ))}
    </fieldset>
  );
}
